"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_UNMUTABLE_COMPATIBLE = exports.isUnmutableCompatible = void 0;

var isUnmutableCompatible = function isUnmutableCompatible(ii) {
  return !ii ? false : !!ii[IS_UNMUTABLE_COMPATIBLE];
};

exports.isUnmutableCompatible = isUnmutableCompatible;
var IS_UNMUTABLE_COMPATIBLE = '__UNMUTABLE_COMPATIBLE__';
exports.IS_UNMUTABLE_COMPATIBLE = IS_UNMUTABLE_COMPATIBLE;